module.exports = __webpack_public_path__ + "img/tu3.d96b1bac.png";